import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchUsers, updateUser, updateUserActiveness, updateUserFromAdmin } from "../features/user/userSlice";
import { formatDate } from "../utils";
import { toast, ToastContainer } from "react-toastify";

const UsersListLayer = () => {
  const [fetchedUsers, setFetchedUsers] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editForm, setEditForm] = useState({ username: "", role: "admin" });

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [selectedUserForPassword, setSelectedUserForPassword] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      const { payload } = await dispatch(fetchUsers());
      setFetchedUsers(payload);
    };
    fetchData();
  }, [dispatch]);

  const users = fetchedUsers || [
  // const users = [
    {
      id: 1,
      date: "25 Jan 2024",
      username: "Kathryn Murphy",
      email: "osgoodwy@gmail.com",
      role: "Admin",
      image: "assets/images/user-list/user-list1.png",
    },
    {
      id: 2,
      date: "25 Jan 2024",
      username: "Annette Black",
      email: "redaniel@gmail.com",
      role: "Editor",
      image: "assets/images/user-list/user-list2.png",
    },
    {
      id: 3,
      date: "10 Feb 2024",
      username: "Ronald Richards",
      email: "seannand@mail.ru",
      role: "Viewer",
      image: "assets/images/user-list/user-list3.png",
    },
    // Add other users here...
  ];

  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 5; // Number of users per page
  const [itemsPerPage, setItemsPerPage] = useState(5);

  // const totalPages = Math.ceil(users.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  
  const submitUpdate = async () => {
      const result = await dispatch(updateUser({ id: editUser?._id, updatedData: editForm }));
      if(result.payload.success){
        setShowEditModal(false);
        toast.success("Employee updated successfully.");
        window.location.reload();
      }
  }

  const filteredUsers = [...users]
  .filter((user) =>
    user.username?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
    user.email?.toLowerCase().includes(searchQuery?.toLowerCase())
  )
  .filter((user) => (selectedRole ? user.role === selectedRole : true));

const sortedUsers = filteredUsers.sort((a, b) => {
  const rolePriority = (role) => {
    if (role === "superadmin") return 0;
    if (role === "admin") return 1;
    return 2;
  };
  return rolePriority(a.role) - rolePriority(b.role);
});

const totalPages = Math.ceil(sortedUsers.length / itemsPerPage);

  // const paginatedUsers = sortedUsers?.filter(user => !user.oAuth)?.slice(
  const paginatedUsers = sortedUsers?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  const handleActiveStatus = (id, currentActive) => {
    dispatch(updateUserActiveness({ id, updatedData: { active: !currentActive } }));
    window.location.reload();
  }

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <span className="text-md fw-medium text-secondary-light mb-0">Show</span>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1); // Reset to first page on change
            }}
          >
            {[5, 10, 15, 20, 25, 50].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>

          <form className="navbar-search">
            <input
              type="text"
              className="bg-base h-40-px w-auto"
              name="search"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Icon icon="ion:search-outline" className="icon" />
          </form>

          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="">All Roles</option>
            <option value="superadmin">Super Admin</option>
            <option value="admin">Admin</option>
            {Array.from(
              new Set(fetchedUsers.map((u) => u.role).filter((r) => r !== "admin" && r !== "superadmin"))
            ).sort().map((role) => (
              <option key={role} value={role}>
                {role.charAt(0).toUpperCase() + role.slice(1)}
              </option>
            ))}
          </select>

        </div>
        <Link
          to="/add-user"
          className="btn btn-bg text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
          Add New Employee
        </Link>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input radius-4 border input-form-dark"
                        type="checkbox"
                        name="checkbox"
                        id="selectAll"
                      />
                    </div>
                    S.L
                  </div>
                </th>
                <th scope="col">Join Date</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col" className="text-center">
                  Role
                </th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.map((user, index) => (
                <tr key={user._id}>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center">
                        <input
                          className="form-check-input radius-4 border border-neutral-400"
                          type="checkbox"
                          name="checkbox"
                        />
                      </div>
                      {String((currentPage - 1) * itemsPerPage + index + 1).padStart(2, "0")}
                    </div>
                  </td>
                  <td>{user?.date ?? formatDate(user?.createdAt)}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <img
                        src={user?.image ?? "assets/images/user-list/user-list1.png"}
                        alt={user.username}
                        className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                      />
                      <div className="flex-grow-1">
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {/* {user.username} */}
                          {user.name}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="text-md mb-0 fw-normal text-secondary-light">
                      {user.email}
                    </span>
                  </td>
                  <td className="text-center">
                    <span
                      className={`${
                        user.role === "superadmin"
                          ? "bg-success-focus text-success-600 border border-success-main"
                          : user.role === "admin"
                          ? "bg-warning-focus text-warning-600 border border-warning-main"
                          : "bg-neutral-200 text-neutral-600 border border-neutral-400"
                      } px-24 py-4 radius-4 fw-medium text-sm`}
                    >
                      {user.role==='superadmin' ? "Super Admin" : user.role.slice(0, 1).toUpperCase() + user.role.slice(1)}
                    </span>
                  </td>
                  <td className="text-center">
                    <div className="d-flex align-items-center gap-10 justify-content-center">
                      {user.role === 'user' && <button
                        type="button"
                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        onClick={() => handleActiveStatus(user._id, user.active)}
                      >
                        {
                        user.active ? <Icon icon="majesticons:eye-line" className="icon text-xl" />
                        :
                        <Icon icon="majesticons:eye-off-line" className="icon text-xl" />
                        }
                      </button>}
                      {(user.role === 'user' && !user.oAuth) && <button
                        type="button"
                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        onClick={() => {
                          setSelectedUserForPassword(user);
                          setNewPassword("");
                          setConfirmPassword("");
                          setShowPasswordModal(true);
                        }}
                      >
                        {
                        user.active ? <Icon icon="lucide:lock" className="icon text-xl" />
                        :
                        <Icon icon="lucide:lock" className="icon text-xl" />
                        }
                      </button>}
                      {(user.role === 'user' && user.oAuth === true) && <button
                        type="button"
                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        disabled={true}
                        onClick={() => {
                          setSelectedUserForPassword(user);
                          setNewPassword("");
                          setConfirmPassword("");
                          setShowPasswordModal(true);
                        }}
                      >
                        {
                        user.active ? <Icon icon="lucide:fingerprint" className="icon text-xl" />
                        :
                        <Icon icon="lucide:fingerprint" className="icon text-xl" />
                        }
                      </button>}
                      { user.role !== "user" && <button
                        type="button"
                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        onClick={() => {
                          setEditUser(user);
                          setEditForm({ username: user.username, role: user.role });
                          setShowEditModal(true);
                        }}
                      >
                        <Icon icon="lucide:edit" className="menu-icon" />
                      </button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
            {Math.min(currentPage * itemsPerPage, sortedUsers.length)} of {sortedUsers.length} entries
          </span>
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            <li className="page-item">
              <button
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                onClick={() => handlePageChange(currentPage - 1)}
              >
                <Icon icon="ep:d-arrow-left" className="" />
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <li key={page} className="page-item">
                <button
                  className={`page-link ${
                    page === currentPage
                      ? "bg-primary-600 text-white"
                      : "bg-neutral-200 text-secondary-light"
                  } fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              </li>
            ))}
            <li className="page-item">
              <button
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                onClick={() => handlePageChange(currentPage + 1)}
              >
                <Icon icon="ep:d-arrow-right" className="" />
              </button>
            </li>
          </ul>
        </div>
      </div>
      {showEditModal && (
  <div className="modal-overlay">
    <div className="modal-content radius-12 p-24 bg-white shadow">
      <h5>Edit User</h5>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <input
          type="text"
          className="form-control"
          value={editForm.username}
          onChange={(e) =>
            setEditForm((prev) => ({ ...prev, username: e.target.value }))
          }
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Role</label>
        <select
          className="form-select"
          value={editForm.role}
          onChange={(e) =>
            setEditForm((prev) => ({ ...prev, role: e.target.value }))
          }
        >
          <option value="admin">Admin</option>
          <option value="superadmin">Super Admin</option>
        </select>
      </div>
      <div className="d-flex gap-2 mt-3">
        <button
          className="btn btn-primary"
          onClick={submitUpdate}
        >
          Save
        </button>
        <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
      {showPasswordModal && (
        <div className="modal-overlay">
          <div className="modal-content radius-12 p-24 bg-white shadow">
            <h5>Change Password</h5>
            <p className="text-sm text-secondary-light mb-16">
              Set a new password for <strong>{selectedUserForPassword?.name || selectedUserForPassword?.email}</strong>.
            </p>
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Re-enter new password"
              />
            </div>
            <div className="d-flex gap-2 mt-3">
              <button
                className="btn btn-primary"
                disabled={isChangingPassword}
                onClick={async () => {
                  if (!newPassword.trim()) {
                    toast.error("Password cannot be empty.");
                    return;
                  }

                  if (newPassword !== confirmPassword) {
                    toast.error("Passwords do not match.");
                    return;
                  }

                  if (!selectedUserForPassword?._id) {
                    toast.error("No user selected.");
                    return;
                  }

                  try {
                    setIsChangingPassword(true);
                    const result = await dispatch(
                      updateUserFromAdmin({
                        id: selectedUserForPassword._id,
                        updatedData: { password: newPassword },
                      })
                    );

                    if (result.payload?.success) {
                      toast.success(result?.payload?.message);
                      // toast.success("Password updated successfully.");
                      setShowPasswordModal(false);
                      setSelectedUserForPassword(null);
                      setNewPassword("");
                      setConfirmPassword("");
                    } else {
                      toast.error(result.payload?.message || "Failed to update password.");
                    }
                  } catch (error) {
                    toast.error("Failed to update password.");
                  } finally {
                    setIsChangingPassword(false);
                  }
                }}
              >
                {isChangingPassword ? "Updating..." : "Change Password"}
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowPasswordModal(false);
                  setSelectedUserForPassword(null);
                  setNewPassword("");
                  setConfirmPassword("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default UsersListLayer;
